import {
	DEFAULT, DRIVETRAIN, FeatureGroup, HUB, KPI_TABLE, RELIABILITY
} from "@/constants/generating-unit-features/GeneratingUnitFeaturesGroup";

/**
 * Cria um estado inicial vazio para diferentes grupos de recursos.
 * 
 * - [DEFAULT]: Grupo de funcionalidades padrão.
 *   - [FeatureGroup.DEFAULT.TRENDS]:                - Representa se as tendências estão ativas.
 *   - [FeatureGroup.DEFAULT.REPORTS]:               - Representa se os relatórios estão ativos.
 *   - [FeatureGroup.DEFAULT.AUDIO]:                 - Representa se o áudio está ativo.
 *   - [FeatureGroup.DEFAULT.MAINTENANCE]:           - Representa se a manutenção está ativa.
 *   - [FeatureGroup.DEFAULT.OCCURRENCES]:           - Representa se as ocorrências estão ativas.
 *   - [FeatureGroup.DEFAULT.RAW_RECORDS]:           - Representa se os registros brutos estão ativos.
 *   - [FeatureGroup.DEFAULT.OIL]:                   - Representa se os recursos relacionados
 *  ao óleo estão ativos.
 *   - [FeatureGroup.DEFAULT.KINEMATIC_PARAMETERS]:  - Representa se os parâmetros cinemáticos estão ativos.
 * 
 * - [DRIVETRAIN]: Grupo de funcionalidades relacionadas ao Drivetrain.
 *   - [FeatureGroup.DRIVETRAIN.HEALTH_INDICATOR]:  - Representa se o indicador de saúde está ativo.
 *   - [FeatureGroup.DRIVETRAIN.GLOBAL_VALUES]:     - Representa se os valores globais estão ativos.
 *   - [FeatureGroup.DRIVETRAIN.DIAGNOSTIC]:        - Representa se o diagnóstico está ativo.
 *   - [FeatureGroup.DRIVETRAIN.SCADA_CONNECTED]:   - Representa se o SCADA está conectado.
 * 
 * - [HUB]: Grupo de funcionalidades relacionadas ao Hub.
 *   - [FeatureGroup.HUB.GLOBAL_VALUES]:      - Representa se os valores globais estão ativos no hub.
 *   - [FeatureGroup.HUB.BLADE_GAP]:          - Representa se o gap das lâminas está ativo.
 *   - [FeatureGroup.HUB.BEARING_VIBRATION]:  - Representa se a vibração dos rolamentos está ativa.
 *   - [FeatureGroup.HUB.DRIVE_CURRENT]:      - Representa se a corrente do drive está ativa.
 *   - [FeatureGroup.HUB.HEALTH_INDICATOR]:   - Representa se o indicador de saúde está ativo no hub.
 * 
 * - [KPI_TABLE]: Grupo de funcionalidades relacionadas à tabela de KPI.
 *   - [FeatureGroup.KPI_TABLE.PERFORMANCE_FACTOR]:  - Representa se o fator de desempenho está ativo.
 *   - [FeatureGroup.KPI_TABLE.CAPACITY_FACTOR]:     - Representa se o fator de capacidade está ativo.
 *   - [FeatureGroup.KPI_TABLE.HEALTH_INDICATOR]:    - Representa se o indicador 
 * de saúde está ativo na tabela KPI.
 * 
 * - [RELIABILITY]: Grupo de funcionalidades relacionadas à confiabilidade.
 *   - [FeatureGroup.RELIABILITY.DASHBOARD]:  - Representa se o dashboard de confiabilidade está ativo.
 *   - [FeatureGroup.RELIABILITY.CURVES]:     - Representa se as curvas de confiabilidade estão ativas.
 * @returns {Object} - Retorna o estado inicial vazio com os grupos e recursos definidos como .
 */
const EmptyState = function()
{
	return {
		[DEFAULT]: {
			[FeatureGroup.DEFAULT.TRENDS]:               false,
			[FeatureGroup.DEFAULT.REPORTS]:              false,
			[FeatureGroup.DEFAULT.AUDIO]:                false,
			[FeatureGroup.DEFAULT.MAINTENANCE]:          false,
			[FeatureGroup.DEFAULT.OCCURRENCES]:          false,
			[FeatureGroup.DEFAULT.RAW_RECORDS]:          false,
			[FeatureGroup.DEFAULT.OIL]:                  false,
			[FeatureGroup.DEFAULT.KINEMATIC_PARAMETERS]: false,
	  },
	  [DRIVETRAIN]: {
			[FeatureGroup.DRIVETRAIN.HEALTH_INDICATOR]: false,
			[FeatureGroup.DRIVETRAIN.GLOBAL_VALUES]:    false,
			[FeatureGroup.DRIVETRAIN.DIAGNOSTIC]:       false,
			[FeatureGroup.DRIVETRAIN.SCADA_CONNECTED]:  false,
	  },
	  [HUB]: {
			[FeatureGroup.HUB.GLOBAL_VALUES]:     false,
			[FeatureGroup.HUB.BLADE_GAP]:         false,
			[FeatureGroup.HUB.BEARING_VIBRATION]: false,
			[FeatureGroup.HUB.DRIVE_CURRENT]:     false,
			[FeatureGroup.HUB.HEALTH_INDICATOR]:  false,
	  },
	  [KPI_TABLE]: {
			[FeatureGroup.KPI_TABLE.PERFORMANCE_FACTOR]: false,
			[FeatureGroup.KPI_TABLE.CAPACITY_FACTOR]:    false,
			[FeatureGroup.KPI_TABLE.HEALTH_INDICATOR]:   false,
	  },
	  [RELIABILITY]: {
			[FeatureGroup.RELIABILITY.DASHBOARD]: false,
			[FeatureGroup.RELIABILITY.CURVES]:    false,
	  },
	};
};

export default { EmptyState };